import { render } from "./BasketballModal.vue?vue&type=template&id=554cf131&scoped=true"
import script from "./BasketballModal.vue?vue&type=script&lang=js"
export * from "./BasketballModal.vue?vue&type=script&lang=js"

import "./BasketballModal.vue?vue&type=style&index=0&id=554cf131&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554cf131"]])

export default __exports__